<mat-dialog-actions class="justify-content-between p-b-0" *ngIf="!patientId">
    <h4 class="f-s-16 f-w-600">
        {{ 'LABEL.APPOINTMENT_HISTORY_OF' | translate}}:
        <span style="color: var(--mat-sys-primary);">{{patientFullName}}</span>
    </h4>
    <a mat-icon-button class="d-flex align-items-center" (click)="printHistory()">
        <i-tabler name="printer" class="text-primary icon-30 d-flex"></i-tabler>
    </a>
</mat-dialog-actions>
<mat-divider *ngIf="!patientId"></mat-divider>

<div *ngIf="isLoading" class="loader-wrapper">
    <mat-spinner diameter="40"></mat-spinner>
</div>

<mat-card *ngIf="!isLoading">
    <mat-card-content class="p-10">

        <!-- Table Section -->
        <div class="table-container table-wrapper" [ngClass]="{'embedded-view': !!patientId, 'dialog-view': isDialogMode}">
            <div class="table-responsive">
                <ng-container *ngIf="dataSource.data.length>0">
                    <table mat-table [dataSource]="dataSource" class="w-100">
                        <ng-container matColumnDef="appointTime">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 m-0" sticky>{{
                                'LABEL.TIME' | translate }}</th>
                            <td mat-cell *matCellDef="let element" class="p-x-16">{{ element.appointTime| timeFormat }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="appointDate">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 " sticky>{{ 'LABEL.DATE' |
                                translate }}</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="p-x-16">
                                {{ element.appointDate|date:'dd-MM-yyyy'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="appointmentTypeName">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 " sticky>{{ 'LABEL.NAME' |
                                translate }}</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="p-x-16">
                                {{ element.appointmentTypeName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="OPDNO">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 " sticky>{{ 'LABEL.OPD_NO' |
                                translate }}</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="p-x-16">
                                {{ element.opdNumber}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 " sticky>{{ 'LABEL.STATUS' |
                                translate }}</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="p-x-16">
                                {{ element.status}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Charge">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 " sticky>Charge</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="p-x-16">
                                {{element.charge}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="viewDetails">
                            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 " sticky>Details</th>
                            <td mat-cell *matCellDef="let element; let i = index" class="p-x-16">
                                <div class="d-flex align-items-center gap-10 action-row">
                                    <a mat-icon-button class="d-flex justify-content-center"
                                        (click)="viewDetails(element)" *ngIf="!showOPD">
                                        <i-tabler name="eye" class="text-primary icon-18 d-flex" style="cursor: pointer;"></i-tabler>
                                    </a>
                                    <a matTooltip="Start Consultation"
                                        *ngIf="isTodayOrInThePast(element.appointDate) && !element.opdNumber && showOPD"
                                        (click)="StartConsultation(element)"  style="cursor: pointer;">
                                        <i-tabler name="message" class="icon-18"></i-tabler>
                                    </a>
                                    <a matTooltip="Edit/View Consultation" *ngIf="element.opdNumber && showOPD"
                                        (click)="StartConsultation(element)" style="cursor: pointer;">
                                        <i-tabler name="eye-edit" class="icon-18"></i-tabler>
                                    </a>

                                    <!-- Delete -->
                                    <a matTooltip="Delete" *ngIf="!element.opdNumber && showOPD"
                                        (click)="OnDeleteAppointment(element)" style="cursor: pointer;">
                                        <i-tabler name="trash" class="icon-18 cursor-point"></i-tabler>
                                    </a>    
                                    <a *ngIf="showOPD && element.opdNumber" [matMenuTriggerFor]="menu" style="cursor: pointer;">
                                        <i-tabler name="dots-vertical" class="icon-20"></i-tabler>
                                    </a>
                                </div>

                                <mat-menu #menu="matMenu">
                                    <a mat-menu-item *ngIf="element.opdNumber" (click)="listOfPatientReport(element)" class="cursor-point">
                                        {{ 'ENTITY.PATIENT' | translate }} {{ 'LABEL.REPORT' | translate }}
                                    </a>
                                    <a mat-menu-item *ngIf="element.opdNumber" (click)="OnBillChargeAdd(element)" class="cursor-point">
                                        {{ 'ENTITY.BILL' | translate }} {{ 'LABEL.RECEIPT' | translate }}
                                    </a>
                                </mat-menu>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="align-items-center"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;let element"
                            [ngClass]="{'ipd-row': isIPD && row?.ipdId}">
                        </tr>
                    </table>
                </ng-container>
            </div>

        </div>

    </mat-card-content>
</mat-card>